import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
};
const breadcrumbSlice = createSlice({
  name: "breadcrumb",
  initialState,
  reducers: {
    addItem: (state, item) => {
      if (state.items.length > 0) {
        if (state.items[state.items.length - 1].level == item.payload.level) {
          state.items.pop();
          state.items.push(item.payload);
        } else if (
          state.items[state.items.length - 1].level < item.payload.level
        ) {
          state.items.push(item.payload);
        } else {
          const index = state.items.findIndex(
            (element) => element.level === item.payload.level
          );
          if (index !== -1) {
            state.items = state.items.slice(0, index + 1);
          }
        }
      } else {
        state.items.push(item.payload);
      }
    },
  },
});
export const { addItem } = breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;
